import { render, staticRenderFns } from "./collectInvoiceWindow.vue?vue&type=template&id=431c680c&scoped=true&"
import script from "./collectInvoiceWindow.vue?vue&type=script&lang=js&"
export * from "./collectInvoiceWindow.vue?vue&type=script&lang=js&"
import style0 from "./collectInvoiceWindow.vue?vue&type=style&index=0&id=431c680c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431c680c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('431c680c')) {
      api.createRecord('431c680c', component.options)
    } else {
      api.reload('431c680c', component.options)
    }
    module.hot.accept("./collectInvoiceWindow.vue?vue&type=template&id=431c680c&scoped=true&", function () {
      api.rerender('431c680c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/makeInvoice/collectInvoiceWindow.vue"
export default component.exports